





Currency = require 'models/currency.coffee'

module.exports =
  name: 'period_by_months_chart'
  props: ['transactions']
  watch:
    transactions: ->
      @drawChart()
  mounted: ->
    @drawChart()
  computed:
    chart_data: ->
      chart_data_array = []

      all_trs = _.orderBy @transactions.incomes.all.concat(@transactions.expenses.all), 'date'
      min_date = _.first(all_trs)?.date

      while min_date <= _.last(all_trs)?.date
        min_date = hm_date.startOfMonth(min_date)
        month = hm_date.format(min_date)
        income = @$store.getters.transactions_sum(@transactions.incomes.by_months[month])
        expense = Math.abs @$store.getters.transactions_sum(@transactions.expenses.by_months[month])
        chart_data_array.push
          month: min_date
          date_string: hm_date.format(min_date, 'MMM YY')
          net: income - expense
          income: income
          expense: expense
        min_date = hm_date.addMonths_f(min_date, 1)

      has_incomes  = _.compact(_.map(chart_data_array, 'income')).length
      has_expenses = _.compact(_.map(chart_data_array, 'expense')).length
      return
        has_incomes:  has_incomes
        has_expenses: has_expenses
        has_nets:     (has_incomes && has_expenses)
        values: chart_data_array

    graphs: (stats, _animate) ->
      stats = @chart_data
      graphs = []

      # display incomes graph only if there're any incomes
      if stats.has_incomes
        graphs.push
          type: 'column'
          title: _.capitalize(@$t('income'))
          valueField: 'income'
          fillColors: '#3F9142'
          fillAlphas: 0.9
          lineAlpha: 0
          balloonFunction: (item, graph) =>
            _.capitalize(@$t('income')) + ': ' + Currency.format
              value: item.dataContext.income
              currency: @$store.getters.default_currency
              color: false
              sign: 'none'
          balloon: { fillAlpha: 1 }
          animationPlayed: true # don't play animation
          # showHandOnHover: true # enable later

      # display expenses graph only if there're any expenses
      if stats.has_expenses
        graphs.push
          type: 'column'
          title: 'Расходы'
          valueField: 'expense'
          fillColors: '#BA2525'
          fillAlphas: 0.9
          lineAlpha: 0
          balloonFunction: (item, graph) =>
            _.capitalize(@$t('expenses')) + ': ' + Currency.format
              value: -item.dataContext.expense
              currency: @$store.getters.default_currency
              color: false
              sign: 'none'
          balloon: { fillAlpha: 1 }
          animationPlayed: true # don't play animation
          # showHandOnHover: true # enable later

      # display nets line only if there're any nets
      if stats.has_nets
        graphs.push
          type: 'smoothedLine'
          title: 'Разница'
          valueField: 'net'
          # bulletField: 'bullet'
          bullet: 'round'
          lineColor: '#653CAD'
          negativeLineColor: 'red'
          bulletSize: 3
          bulletBorderAlpha: 1
          lineThickness: 1
          useLineColorForBulletBorder: true
          bulletColor: '#FFFFFF'
          balloonFunction: (item, graph) =>
            _.capitalize(@$t('net')) + ': ' + Currency.format
              value: item.dataContext.net
              currency: @$store.getters.default_currency
              color: false
              sign: 'none'
          balloon: { fillAlpha: 1 }
          animationPlayed: true # don't play animation
          # showHandOnHover: true # enable later
      return graphs
  methods:
    drawChart: ->
      nets = _.map(@chart_data.values, 'net')
      if nets.every((net) -> net > 0) || nets.every((net) -> net < 0)
        minimum = 0

      chart = AmCharts.makeChart $(@$el).find('.chart')[0],
        pathToImages: '/amcharts-images/'
        type: 'serial'
        theme: 'light'
        fontFamily: 'Inter'
        dataDateFormat: 'YYYY-MM-DD'
        categoryField: 'date_string'
        dataProvider: @chart_data.values
        columnSpacing: 0
        startDuration: 1
        marginTop: 5
        marginRight: 10
        categoryAxis:
          gridPosition: 'start'
          autoRotateAngle: 45
          autoRotateCount: 11
        valueAxes: [{
          # labelFunction: (value, valueText, valueAxis) -> HM.format.money_default(value)
          minimum: minimum
          includeAllValues: true # If you set it to true, minimum and maximum of value axis will not change while zooming/scrolling.
          usePrefixes: true
        }],
        graphs: @graphs
        legend: { enabled: false }
        chartCursor: { }
      return chart

    add_events: (chart) ->
      true
      # TODO: enable showHandOnHover: true to display hand cursor
      # chart.addListener 'clickGraphItem', (event) =>
      #   date = event.item.dataContext.date
      #   # period =
      #   #   start: hm_date.parse(date)
      #   #   end: hm_date.endOfMonth(date)
      #   #   label: event.item.dataContext.date_string
      #   # @drawer.reports_page_ctrl.display_modal period, @drawer.period.categories
      #   @drawer.period.highlightMonth date

